<template>
  <div class="content se-main-panel">
    <div class="container-fluid">
<!--      <transition name="fade" mode="out-in">-->
        <!-- your content here -->
        <router-view></router-view>
<!--      </transition>-->
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .1s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }

  .se-main-panel{
    margin-top: 60px;
  }

</style>
